import { createContext, useContext } from 'react';
import noop, { NoOp } from 'utils/noop';
import { Button } from 'modules/graphql/types';
import { PreviewWithDataErrorMessage } from '../../common';

export interface EmbeddedPreviewContextState {
  isLoading: boolean;
  title?: string;
  body?: string;
  actionButtons?: Button[];
  mediaUrl?: string;
  hasContent: boolean;
  previewError?: PreviewWithDataErrorMessage;
  onRefreshPreview: NoOp;
}

export const EmbeddedPreviewContext = createContext<EmbeddedPreviewContextState>({
  isLoading: false,
  title: '',
  body: '',
  actionButtons: [],
  mediaUrl: '',
  hasContent: false,
  previewError: undefined,
  onRefreshPreview: noop,
});

export const useEmbeddedPreviewContext = () => useContext(EmbeddedPreviewContext);
